/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptAIFieldRequest } from '../models/AcceptAIFieldRequest';
import type { AcceptAIFieldResponse } from '../models/AcceptAIFieldResponse';
import type { AcceptAllAIFieldsResponse } from '../models/AcceptAllAIFieldsResponse';
import type { AIReviewBatchRequest } from '../models/AIReviewBatchRequest';
import type { AIReviewBatchResponse } from '../models/AIReviewBatchResponse';
import type { AllocationCompanyModel } from '../models/AllocationCompanyModel';
import type { CapTableDetailsModel } from '../models/CapTableDetailsModel';
import type { CapTableFundOwnership } from '../models/CapTableFundOwnership';
import type { CapTableGrossIRRResponse } from '../models/CapTableGrossIRRResponse';
import type { CapTableGrossIRRsResponse } from '../models/CapTableGrossIRRsResponse';
import type { CapTableModel } from '../models/CapTableModel';
import type { CapTableSecurities } from '../models/CapTableSecurities';
import type { CashFlowLedgerBulkSave } from '../models/CashFlowLedgerBulkSave';
import type { CashFlowLedgerItem } from '../models/CashFlowLedgerItem';
import type { CitationReviewRequest } from '../models/CitationReviewRequest';
import type { CitationReviewResponse } from '../models/CitationReviewResponse';
import type { CustomBreakpoints } from '../models/CustomBreakpoints';
import type { DismissAIFieldRequest } from '../models/DismissAIFieldRequest';
import type { DismissAIFieldResponse } from '../models/DismissAIFieldResponse';
import type { ProFormaCapTableModel } from '../models/ProFormaCapTableModel';
import type { RecalculateSecurities } from '../models/RecalculateSecurities';
import type { RecalculateSecuritiesResponse } from '../models/RecalculateSecuritiesResponse';
import type { ReopenAIFieldRequest } from '../models/ReopenAIFieldRequest';
import type { ReopenAIFieldResponse } from '../models/ReopenAIFieldResponse';
import type { UpdateFundOwnershipResponse } from '../models/UpdateFundOwnershipResponse';
import type { WaterfallInvestedCapitalResponse } from '../models/WaterfallInvestedCapitalResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CapTablesService {
  /**
   * Accept or dismiss a single CitationReference by id (SCAL-8963).
   * PATCH /api/cap-tables/citations/<citation_id>/review
   * @param citationId
   * @param data
   * @returns CitationReviewResponse
   * @throws ApiError
   */
  public static apiCapTablesCitationsReviewPartialUpdate(
    citationId: string,
    data: CitationReviewRequest,
  ): CancelablePromise<CitationReviewResponse> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/cap-tables/citations/{citation_id}/review',
      path: {
        'citation_id': citationId,
      },
      body: data,
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static apiCapTablesImportExtractedCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/cap-tables/import-extracted',
    });
  }
  /**
   * @param data
   * @returns ProFormaCapTableModel
   * @throws ApiError
   */
  public static apiCapTablesProFormaCreate(
    data: ProFormaCapTableModel,
  ): CancelablePromise<ProFormaCapTableModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/cap-tables/pro-forma',
      body: data,
    });
  }
  /**
   * Recalculate Security Values, without persisting
   * @param data
   * @returns RecalculateSecuritiesResponse
   * @throws ApiError
   */
  public static apiCapTablesRecalculateSecuritiesCreate(
    data: RecalculateSecurities,
  ): CancelablePromise<RecalculateSecuritiesResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/cap-tables/recalculate-securities',
      body: data,
    });
  }
  /**
   * @param securityId
   * @param data
   * @returns AcceptAIFieldResponse
   * @throws ApiError
   */
  public static apiCapTablesSecuritiesAcceptAiFieldsPartialUpdate(
    securityId: string,
    data: AcceptAIFieldRequest,
  ): CancelablePromise<AcceptAIFieldResponse> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/cap-tables/securities/{security_id}/accept-ai-fields',
      path: {
        'security_id': securityId,
      },
      body: data,
    });
  }
  /**
   * @param securityId
   * @param data
   * @returns DismissAIFieldResponse
   * @throws ApiError
   */
  public static apiCapTablesSecuritiesDismissAiFieldsPartialUpdate(
    securityId: string,
    data: DismissAIFieldRequest,
  ): CancelablePromise<DismissAIFieldResponse> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/cap-tables/securities/{security_id}/dismiss-ai-fields',
      path: {
        'security_id': securityId,
      },
      body: data,
    });
  }
  /**
   * Reopen settled AI review fields to pending (SCAL-9262).
   * PATCH /api/cap-tables/securities/<security_id>/reopen-ai-fields
   * @param securityId
   * @param data
   * @returns ReopenAIFieldResponse
   * @throws ApiError
   */
  public static apiCapTablesSecuritiesReopenAiFieldsPartialUpdate(
    securityId: string,
    data: ReopenAIFieldRequest,
  ): CancelablePromise<ReopenAIFieldResponse> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/cap-tables/securities/{security_id}/reopen-ai-fields',
      path: {
        'security_id': securityId,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this cap table.
   * @returns CapTableDetailsModel
   * @throws ApiError
   */
  public static apiCapTablesRead(
    id: number,
  ): CancelablePromise<CapTableDetailsModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/cap-tables/{id}',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this cap table.
   * @param data
   * @returns CapTableDetailsModel
   * @throws ApiError
   */
  public static apiCapTablesUpdate(
    id: number,
    data: CapTableDetailsModel,
  ): CancelablePromise<CapTableDetailsModel> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/cap-tables/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this cap table.
   * @param data
   * @returns CapTableDetailsModel
   * @throws ApiError
   */
  public static apiCapTablesPartialUpdate(
    id: number,
    data: CapTableDetailsModel,
  ): CancelablePromise<CapTableDetailsModel> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/cap-tables/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * Accept all AI field findings for every security in a cap table in a single request.
   * SCAL-9335: uses the AI-review permission (EDIT required, no
   * FULL_ACCESS_VIEWER pro-forma carve-out) - view-only users are rejected.
   * @param id
   * @returns AcceptAllAIFieldsResponse
   * @throws ApiError
   */
  public static apiCapTablesAcceptAllAiFieldsPartialUpdate(
    id: string,
  ): CancelablePromise<AcceptAllAIFieldsResponse> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/cap-tables/{id}/accept-all-ai-fields',
      path: {
        'id': id,
      },
    });
  }
  /**
   * Bulk accept/decline AI review fields across many securities in a cap table.
   * PATCH /api/cap-tables/<pk>/ai-review-batch
   * @param id
   * @param data
   * @returns AIReviewBatchResponse
   * @throws ApiError
   */
  public static apiCapTablesAiReviewBatchPartialUpdate(
    id: string,
    data: AIReviewBatchRequest,
  ): CancelablePromise<AIReviewBatchResponse> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/cap-tables/{id}/ai-review-batch',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this cap table.
   * @returns CapTableDetailsModel
   * @throws ApiError
   */
  public static apiCapTablesAllBreakpointsRead(
    id: number,
  ): CancelablePromise<CapTableDetailsModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/cap-tables/{id}/all-breakpoints',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this cap table.
   * @param data
   * @returns CustomBreakpoints
   * @throws ApiError
   */
  public static apiCapTablesAllBreakpointsUpdate(
    id: number,
    data: CustomBreakpoints,
  ): CancelablePromise<CustomBreakpoints> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/cap-tables/{id}/all-breakpoints',
      path: {
        'id': id,
      },
      body: data,
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this cap table.
   * @param data
   * @returns CapTableDetailsModel
   * @throws ApiError
   */
  public static apiCapTablesAllBreakpointsPartialUpdate(
    id: number,
    data: CapTableDetailsModel,
  ): CancelablePromise<CapTableDetailsModel> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/cap-tables/{id}/all-breakpoints',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * GET /api/cap-tables/<pk>/cash-flow-ledger
   * Returns combined saved + virtualized cash flow items for the cap table, sorted by date ascending.
   * @param id
   * @returns CashFlowLedgerItem
   * @throws ApiError
   */
  public static apiCapTablesCashFlowLedgerList(
    id: string,
  ): CancelablePromise<CashFlowLedgerItem> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/cap-tables/{id}/cash-flow-ledger',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns any Successfully saved cash flow ledger items
   * @throws ApiError
   */
  public static apiCapTablesCashFlowLedgerBulkSaveCreate(
    id: string,
    data: CashFlowLedgerBulkSave,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/cap-tables/{id}/cash-flow-ledger/bulk-save',
      path: {
        'id': id,
      },
      body: data,
      errors: {
        400: `Validation error`,
        404: `Cap Table not found`,
      },
    });
  }
  /**
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static apiCapTablesCheckAssociatedMeasurementDateList(
    id: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/cap-tables/{id}/check-associated-measurement-date',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this fund ownership.
   * @returns CapTableFundOwnership
   * @throws ApiError
   */
  public static apiCapTablesFundOwnershipRead(
    id: number,
  ): CancelablePromise<CapTableFundOwnership> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/cap-tables/{id}/fund-ownership',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this fund ownership.
   * @param data
   * @returns UpdateFundOwnershipResponse
   * @throws ApiError
   */
  public static apiCapTablesFundOwnershipUpdate(
    id: number,
    data: CapTableFundOwnership,
  ): CancelablePromise<UpdateFundOwnershipResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/cap-tables/{id}/fund-ownership',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this fund ownership.
   * @param data
   * @returns CapTableFundOwnership
   * @throws ApiError
   */
  public static apiCapTablesFundOwnershipPartialUpdate(
    id: number,
    data: CapTableFundOwnership,
  ): CancelablePromise<CapTableFundOwnership> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/cap-tables/{id}/fund-ownership',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this cap table.
   * @returns UpdateFundOwnershipResponse
   * @throws ApiError
   */
  public static apiCapTablesFundOwnershipCopyFromPrimaryCreate(
    id: number,
  ): CancelablePromise<UpdateFundOwnershipResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/cap-tables/{id}/fund-ownership/copy-from-primary',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id
   * @returns AllocationCompanyModel
   * @throws ApiError
   */
  public static apiCapTablesGotFinalAllocationRead(
    id: string,
  ): CancelablePromise<AllocationCompanyModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/cap-tables/{id}/got-final-allocation',
      path: {
        'id': id,
      },
    });
  }
  /**
   * Get gross IRR for a specific cap table and fund
   * Computes the gross IRR for the specified cap table and fund using the provided unrealized value at the given exit_date.
   * @param id A unique integer value identifying this cap table.
   * @param fund
   * @param unrealizedValue
   * @param exitDate
   * @returns CapTableGrossIRRResponse
   * @throws ApiError
   */
  public static apiCapTablesGrossIrrRead(
    id: number,
    fund: number,
    unrealizedValue: string,
    exitDate: string,
  ): CancelablePromise<CapTableGrossIRRResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/cap-tables/{id}/gross-irr',
      path: {
        'id': id,
      },
      query: {
        'fund': fund,
        'unrealized_value': unrealizedValue,
        'exit_date': exitDate,
      },
    });
  }
  /**
   * Get per-fund + firm gross IRR for a cap table
   * Computes per-fund and firm-total gross IRR for every fund with FundOwnershipDetail or non-excluded CashFlowLedgerItem on the cap_table. Unrealized values come from the latest published/final AllocationFundConclusion per fund.
   * @param id A unique integer value identifying this cap table.
   * @returns CapTableGrossIRRsResponse
   * @throws ApiError
   */
  public static apiCapTablesGrossIrrsRead(
    id: number,
  ): CancelablePromise<CapTableGrossIRRsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/cap-tables/{id}/gross-irrs',
      path: {
        'id': id,
      },
    });
  }
  /**
   * pk here is id of the company measurement date we're querying a primary captable for
   * @param id A unique integer value identifying this cap table.
   * @returns CapTableDetailsModel
   * @throws ApiError
   */
  public static apiCapTablesPrimaryRead(
    id: number,
  ): CancelablePromise<CapTableDetailsModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/cap-tables/{id}/primary',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns CapTableSecurities
   * @throws ApiError
   */
  public static apiCapTablesSecuritiesUpdate(
    id: string,
    data: CapTableSecurities,
  ): CancelablePromise<CapTableSecurities> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/cap-tables/{id}/securities',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param data
   * @returns CapTableSecurities
   * @throws ApiError
   */
  public static apiCapTablesSecuritiesPartialUpdate(
    id: string,
    data: CapTableSecurities,
  ): CancelablePromise<CapTableSecurities> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/cap-tables/{id}/securities',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this cap table.
   * @param data
   * @returns CapTableModel
   * @throws ApiError
   */
  public static apiCapTablesToggleWaterfallVisibilityUpdate(
    id: number,
    data: CapTableModel,
  ): CancelablePromise<CapTableModel> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/cap-tables/{id}/toggle-waterfall-visibility',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this cap table.
   * @param data
   * @returns CapTableModel
   * @throws ApiError
   */
  public static apiCapTablesToggleWaterfallVisibilityPartialUpdate(
    id: number,
    data: CapTableModel,
  ): CancelablePromise<CapTableModel> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/cap-tables/{id}/toggle-waterfall-visibility',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * Get historical Waterfall Invested Capital totals
   * Returns per-owner Invested Capital in the requested result currency. Fund Ownership follows the selected/proforma fallback rules, while Cash Flow Ledger rows always come from the primary cap table.
   * @param id A unique integer value identifying this cap table.
   * @param targetCurrency
   * @returns WaterfallInvestedCapitalResponse
   * @throws ApiError
   */
  public static apiCapTablesWaterfallInvestedCapitalRead(
    id: number,
    targetCurrency: string,
  ): CancelablePromise<WaterfallInvestedCapitalResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/cap-tables/{id}/waterfall-invested-capital',
      path: {
        'id': id,
      },
      query: {
        'target_currency': targetCurrency,
      },
    });
  }
}
